import { ACTIVE_ITEMS } from '@constants/activeItems';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { LIMIT_ITEMS_SELECT } from '../../../../@constants/Pagination';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const BillingGroupField: FC<{
  value: number[] | null;
  onChange: (value: number[] | null) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation('reservation');

  const {
    HotelApi: {
      settings: {
        revenuManagement: { billingGroup },
      },
    },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['get-billing-groups'],
    queryFn: () => {
      return billingGroup.getAll({
        search: [ACTIVE_ITEMS],
        limit: LIMIT_ITEMS_SELECT,
      });
    },
  });

  const handleChange = (billingGroupId: number | 'all') => {
    if (billingGroupId === 'all') {
      onChange(null);
      return;
    }
    onChange(
      value?.includes(billingGroupId)
        ? value?.filter(id => id !== billingGroupId)
        : [...(value || []), billingGroupId]
    );
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <Box
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink>Billing Groups</InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={value === null}
                  onChange={() => handleChange('all')}
                  sx={{ mr: 1 }}
                />
              }
              label={t('list.filter.all')}
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {data?.map(billingGroup => (
              <FormControlLabel
                key={billingGroup.id}
                control={
                  <Checkbox
                    checked={value?.includes(billingGroup?.id!)}
                    onChange={() => handleChange(billingGroup?.id!)}
                    sx={{ mr: 1 }}
                  />
                }
                label={billingGroup.name}
                sx={{ py: 0.5, pl: 1.5 }}
              />
            ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
